import { render, staticRenderFns } from "./flames.vue?vue&type=template&id=adab98be&"
import script from "./flames.vue?vue&type=script&lang=js&"
export * from "./flames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports